import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { weeklyProgramsAPI } from '../../services/api'
import { FireIcon } from '@heroicons/react/24/outline'

export default function ExerciseSummaryCard({ onNavigate }) {
  const { t } = useTranslation()

  const { data: trendsData, isLoading, isError } = useQuery({
    queryKey: ['scoreTrends', 4],
    queryFn: () => weeklyProgramsAPI.getScoreTrends(4),
    select: (response) => response.data,
    retry: false,
  })

  if (isLoading) {
    return (
      <div className="bg-surface-container border rounded-lg p-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-3" />
        <div className="h-8 bg-gray-200 rounded w-3/4" />
      </div>
    )
  }

  // Backend returns { trends: [...], average_score, best_score, ... }
  // Handle error or missing data gracefully
  const trends = (isError ? [] : trendsData?.trends) || []
  const thisWeek = trends.length > 0 ? trends[0] : null
  const bestScore = trendsData?.best_score || thisWeek?.total_score || null

  return (
    <button
      onClick={() => onNavigate?.('exercises')}
      className="bg-surface-container border rounded-lg p-4 text-left hover:border-orange-300 hover:shadow-sm transition-all w-full"
    >
      <div className="flex items-center mb-3">
        <FireIcon className="h-5 w-5 text-orange-600 mr-2" />
        <h4 className="text-sm font-medium text-gray-700">
          {t('myProgress.exerciseSummary', 'Exercise')}
        </h4>
      </div>
      {trends.length > 0 ? (
        <div className="space-y-1.5">
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">{t('myProgress.weeksTracked', 'Weeks tracked')}</span>
            <span className="text-sm font-semibold text-gray-900">
              {trends.length}
            </span>
          </div>
          {bestScore != null && (
            <div className="flex justify-between">
              <span className="text-xs text-gray-500">{t('myProgress.bestScore', 'Best score')}</span>
              <span className="text-sm font-semibold text-orange-600">{Math.round(Number(bestScore))}</span>
            </div>
          )}
        </div>
      ) : (
        <p className="text-sm text-gray-400">{t('myProgress.noWorkoutsThisWeek', 'No workouts this week')}</p>
      )}
    </button>
  )
}
